import React from 'react';

function Loading({ message }) {
  return (
    <div className="h-screen flex flex-col justify-center items-center">
      <div
        style={{
          width: '24px',
          height: '24px',
          border: '3px solid #e5e7eb',
          borderTop: '3px solid #3766a8',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}
        role="status"
      />
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      <p className="mt-3 text-gray-600">{message ? message : 'Loading...'}</p>
    </div>
  );
}

export default Loading;
